module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-icon",
    style: (_vm.iconStyle),
    on: {
      "click": _vm.click
    }
  }, [(!!_vm.iconName) ? [(_vm.type === 'svg') ? _c('svg', {
    attrs: {
      "width": _vm.size,
      "height": _vm.size,
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": '#' + _vm.iconName,
      "fill": _vm.computedColor
    }
  })]) : (_vm.type === 'iconFont') ? _c('i', {
    class: 'rt-base-icon-font ' + _vm.iconName,
    style: ({
      'font-size': _vm.size + 'px'
    })
  }) : _vm._e()] : (!!_vm.iconSrc) ? _c('img', {
    attrs: {
      "width": _vm.size,
      "height": _vm.size,
      "src": _vm.iconSrc
    },
    on: {
      "error": _vm.errorHandler
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bd3bab3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/icon/rtIcon.vue
// module id = 2080
// module chunks = 137